import React, { Component } from 'react';
import { EditorState, Modifier } from 'draft-js';
import TableIcon from 'material-ui/svg-icons/editor/border-all';
import * as Colors from 'material-ui/styles/colors';

export default class AssetWysiwygTableButton extends Component {
    render() {
        const table = '+=======TABLE=======+\n\n|| Heading 1 || Heading 2 || Heading 3 ||\n| Col A1 | Col A2 | Col A3 |\n\n+===================+\n';

        return (<div className="rdw-option-wrapper" title="Table" onClick={() => {
            const {editorState, onChange} = this.props;
            const contentState = Modifier.replaceText(
                editorState.getCurrentContent(),
                editorState.getSelection(),
                table
            );
            onChange(EditorState.push(editorState, contentState, 'insert-characters'));
        }}><TableIcon color={Colors.darkBlack} /></div>);
    }
}
